import { TenantEntity } from '../TenantEntity'

export class PoList extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get poNo() {
    return this._data.poNo
  }
  set poNo(poNo) {
    this._data.poNo = poNo
  }
  get customerId() {
    return this._data.customerId
  }
  set customerId(customerId) {
    this._data.customerId = customerId || 0
  }
  get poState() {
    return this._data.poState
  }
  set poState(poState) {
    this._data.poState = poState
  }
  get sealesOffice() {
    return this._data.sealesOffice
  }
  set sealesOffice(sealesOffice) {
    this._data.sealesOffice = sealesOffice || 0
  }
  get salesDepartment() {
    return this._data.salesDepartment
  }
  set salesDepartment(salesDepartment) {
    this._data.salesDepartment = salesDepartment || 0
  }
  get sales() {
    return this._data.sales
  }
  set sales(sales) {
    this._data.sales = sales || 0
  }
  get supportor() {
    return this._data.supportor
  }
  set supportor(supportor) {
    this._data.supportor = supportor || 0
  }
  get firstPo() {
    return this._data.firstPo
  }
  set firstPo(firstPo) {
    this._data.firstPo = firstPo || 0
  }
  get valPath() {
    return this._data.valPath
  }
  set valPath(valPath) {
    this._data.valPath = valPath
  }
  get poAmount() {
    return this._data.poAmount
  }
  set poAmount(poAmount) {
    this._data.poAmount = poAmount || 0.0
  }
  get poDeclareAmount() {
    return this._data.poDeclareAmount
  }
  set poDeclareAmount(poDeclareAmount) {
    this._data.poDeclareAmount = poDeclareAmount || 0.0
  }
  get poCurrency() {
    return this._data.poCurrency
  }
  set poCurrency(poCurrency) {
    this._data.poCurrency = poCurrency
  }
  get poExchangeRate() {
    return this._data.poExchangeRate
  }
  set poExchangeRate(poExchangeRate) {
    this._data.poExchangeRate = poExchangeRate || 0.0
  }
  get faContract() {
    return this._data.faContract
  }
  set faContract(faContract) {
    this._data.faContract = faContract
  }
  get commisionDiscount() {
    return this._data.commisionDiscount
  }
  set commisionDiscount(commisionDiscount) {
    this._data.commisionDiscount = commisionDiscount || 0.0
  }
  get opRemarks() {
    return this._data.opRemarks
  }
  set opRemarks(opRemarks) {
    this._data.opRemarks = opRemarks
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get forexPaymentList() {
    return this._data.forexPaymentList
  }
  set forexPaymentList(forexPaymentList) {
    this._data.forexPaymentList = forexPaymentList
  }
}
